package kz.dentalcrm.app.screens.diagnosis.add.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface AddDiagnosisViewEvent : ViewEvent {

    data class AddDiagnosis(
        val naming: String
    ) : AddDiagnosisViewEvent
}